/**
 * @generated SignedSource<<56e7176668b702827a2cbce0b9dba209>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileReportButton_profile$data = {
  readonly name: string;
  readonly userId: any;
  readonly " $fragmentType": "ProfileReportButton_profile";
};
export type ProfileReportButton_profile$key = {
  readonly " $data"?: ProfileReportButton_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileReportButton_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileReportButton_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "e407377c95e43fa703a920fb6e79d5f7";

export default node;
